<script lang="ts" setup>
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { computed } from 'vue';

import { getActiveLocale, setLocale, SUPPORTED_LOCALES_MAP } from '@/locales';

const locale = computed(() => getActiveLocale());

const options = computed(() => Object.entries(SUPPORTED_LOCALES_MAP)
  .map(([value, label]) => ({ label, value })));

const onLocaleChange = (event: any) => {
  setLocale(event.value);
};
</script>

<template>
  <div class="locale-changer">
    <DropDownList
      :value="locale"
      class="custom-dropdown"
      :data-items="options"
      @change="onLocaleChange($event)"
      :text-field="'label'"
      :value-field="'value'"
      :value-primitive="true"
    />
  </div>
</template>
